import {useCallback} from 'react'

import {rowIsExpanded} from '../../../hooks/tanstack-table/helpers/row-api'
import type {Row} from '../../../hooks/tanstack-table/helpers/types'
import {useTableInstance} from '../../../hooks/tanstack-table/providers/table-provider'
import {useEnabledFeatures} from '../../../hooks/use-enabled-features'
import type {MemexItemModel} from '../../../models/memex-item-model'

/** Get all visible rows in the table, filtering out parent group rows and rows that are collapsed. */
export const useGetVisibleRows = () => {
  const tableInstance = useTableInstance()
  const {memex_v8_table_instance} = useEnabledFeatures()
  return useCallback(() => {
    const {flatRows: legacyFlatRows, getRowModel} = tableInstance
    const flatRows = getRowModel ? getRowModel().flatRows : legacyFlatRows
    if (memex_v8_table_instance) {
      return flatRows.filter(r => !r.getIsGrouped() && r.getIsAllParentsExpanded())
    }
    const visibleRows = tableInstance.groupedRows?.reduce((acc: Array<Row<MemexItemModel>>, group) => {
      if (rowIsExpanded(group)) {
        acc.push(...group.subRows)
      }
      return acc
    }, [])
    return visibleRows ?? flatRows
  }, [memex_v8_table_instance, tableInstance])
}
